module.exports = __webpack_public_path__ + "static/img/category-analysis.19780620.svg";